import { useEffect } from 'react';
import type { OperatorDetailsResponse } from 'src/apis/organisation-service/types';
import type { OrganisationDetailsRequest } from 'src/apis/organisation-service/use-organisation-details';
import { useAxios } from 'src/hooks/use-axios';

export function useTsoOrSsoDetails({
  organisationDetails,
}: {
  organisationDetails: OrganisationDetailsRequest;
}) {
  const request = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<OperatorDetailsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const tsoLink = organisationDetails.response?.data._links.tsoDetails?.href;
    const ssoLink = organisationDetails.response?.data._links.ssoDetails?.href;
    const href = tsoLink ?? ssoLink;
    if (href) {
      request.execute(href);
    } else {
      return;
    }
    // oxlint-disable-next-line exhaustive-deps
  }, [organisationDetails.response]);

  return request;
}

export type TsoOrSsoDetailsRequest = ReturnType<typeof useTsoOrSsoDetails>;
